import { render, staticRenderFns } from "./assetsMaterial.vue?vue&type=template&id=502d0004&scoped=true"
import script from "./assetsMaterial.vue?vue&type=script&lang=js"
export * from "./assetsMaterial.vue?vue&type=script&lang=js"
import style0 from "./assetsMaterial.vue?vue&type=style&index=0&id=502d0004&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502d0004",
  null
  
)

export default component.exports